<template>
  <header class="p-3 mb-3 border-bottom">
    <div class="container">
      <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
        <router-link :to="{ name: 'Home' }"
          class="d-flex align-items-center mb-2 mb-lg-0 link-body-emphasis text-decoration-none top-logo">
          <img height="50" src="@/assets/logo.png" alt="纳信科技" class="logo">
        </router-link>

        <ul class="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0 top-menu">
          <li>
            <router-link :to="{ name: 'Home' }" class="nav-link px-2"
              :class="'Home' == this.$route.name ? 'link-secondary' : 'link-body-emphasis'">
              主页
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CatalogTotal' }" class="nav-link px-2"
              :class="'CatalogTotal' == this.$route.name ? 'link-secondary' : 'link-body-emphasis'">
              分类
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Search' }" class="nav-link px-2"
              :class="'Search' == this.$route.name ? 'link-secondary' : 'link-body-emphasis'">
              搜索
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Chat' }" class="nav-link px-2"
              :class="'Chat' == this.$route.name ? 'link-secondary' : 'link-body-emphasis'">
              AI问答
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'About' }" class="nav-link px-2"
              :class="'About' == this.$route.name ? 'link-secondary' : 'link-body-emphasis'">
              关于
            </router-link>
          </li>
        </ul>

        <form class="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3" role="search" method="get" @submit.prevent="search">
          <input name="keyword" v-model="keyword" type="search" class="form-control" placeholder="搜索..."
            aria-label="Search">
        </form>

        <!-- <div class="dropdown text-end">
          <a href="#" class="d-block link-body-emphasis text-decoration-none dropdown-toggle" data-bs-toggle="dropdown"
            aria-expanded="false">
            <img src="https://github.com/mdo.png" alt="mdo" width="32" height="32" class="rounded-circle">
          </a>
          <ul class="dropdown-menu text-small">
            <li><a class="dropdown-item" href="#">New project...</a></li>
            <li><a class="dropdown-item" href="#">Settings</a></li>
            <li><a class="dropdown-item" href="#">Profile</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" href="#">Sign out</a></li>
          </ul>
        </div> -->
      </div>
    </div>
  </header>
</template>


<script>
import { ref, onMounted, watch } from 'vue'
import { useRoute, useRouter } from "vue-router";
export default {
  name: 'PageHeader',
  components: {
  },
  setup() {
    const router = useRouter()
    const route = useRoute()

    const keyword = ref(route.query.keyword || '')
    const search = () => {
      router.push({ name: 'Search', query: { keyword: keyword.value } })
      return false
    }

    onMounted(() => {
      keyword.value = route.query.keyword || ''
    })

    watch(() => route.query.keyword, (newKeyword) => {
      keyword.value = newKeyword || ''
    })

    return {
      keyword,
      search
    }
  }
}
</script>


<style scoped>
.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

.b-example-divider {
  width: 100%;
  height: 3rem;
  background-color: rgba(0, 0, 0, .1);
  border: solid rgba(0, 0, 0, .15);
  border-width: 1px 0;
  box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);
}

.b-example-vr {
  flex-shrink: 0;
  width: 1.5rem;
  height: 100vh;
}

.bi {
  vertical-align: -.125em;
  fill: currentColor;
}

.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
}

.nav-scroller .nav {
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.btn-bd-primary {
  --bd-violet-bg: #712cf9;
  --bd-violet-rgb: 112.520718, 44.062154, 249.437846;

  --bs-btn-font-weight: 600;
  --bs-btn-color: var(--bs-white);
  --bs-btn-bg: var(--bd-violet-bg);
  --bs-btn-border-color: var(--bd-violet-bg);
  --bs-btn-hover-color: var(--bs-white);
  --bs-btn-hover-bg: #6528e0;
  --bs-btn-hover-border-color: #6528e0;
  --bs-btn-focus-shadow-rgb: var(--bd-violet-rgb);
  --bs-btn-active-color: var(--bs-btn-hover-color);
  --bs-btn-active-bg: #5a23c8;
  --bs-btn-active-border-color: #5a23c8;
}

.bd-mode-toggle {
  z-index: 1500;
}

.bd-mode-toggle .dropdown-menu .active .bi {
  display: block !important;
}

.top-logo {
  margin-right: 15px;
}
</style>